import { Container } from '@cgs/wge';
import { SLOT_GAME_SETTINGS_TOKEN, SlotGameSettings } from '../slot-game-settings';

export const SLOT_GAME_CONFIG_MANAGER_TOKEN = Symbol('SlotGameConfigManager');

export class SlotGameConfigManager {
  protected slotGameSettings: SlotGameSettings;

  constructor(container: Container) {
    this.slotGameSettings = container.resolve<SlotGameSettings>(SLOT_GAME_SETTINGS_TOKEN);
  }

  public async loadConfig(): Promise<Map<any, any> | null> {
    try {
      const response = await fetch(this.slotGameSettings.getConfigUrl());
      return response.ok ? response.json() : null;
    } catch {
      return null;
    }
  }
}
